import { styled } from '@tmap/mmm-style-guide/src/styled';
import { MenuItem } from '@tmap/mmm-style-guide/src/MenuItem';

export default styled(MenuItem)(({ theme, level = 0 }) => ({
  '& .MuiTypography-root': {
    fontSize: level > 0 ? '14px' : '16px',
  },
  '& .MuiCheckbox-indeterminate+.MuiTypography-root, .Mui-checked+.MuiTypography-root': {
    fontWeight: 500,
  },
  padding: theme.spacing(0.5, 2 + (2 * level)),
}));
